
import { useCallback, useState } from "react";

const useRoomTypeOptions = ({
    roomNumbersByType,
    setRoomNumbersByType,
    setComplementryByType,
    setRoomTypeInfoByType,
    roomTypeInfoByType,
    values,
    setChildrenMinAge,
    setChildrenMaxAge = () => { },
    getCombinedRoomInfo = () => { },

}) => {
    const [isLoading, setIsLoading] = useState(false);

    const ensureTypeOptions = useCallback(
        async (roomId, room, index) => {
            const roomNo = room?.room_id;
            const Unic_key = room?.Unic_key;
            const { checkin_date, checkout_date } = values;

            if (!roomId || !checkin_date || !checkout_date) {
                return null;
            }
            const roomKey = `${roomId}_${Unic_key}`;


            setIsLoading(true);

            try {
                // Already loaded — return cached data
                if (roomTypeInfoByType[roomKey]) {
                    return {
                        roomTypeInfo: roomTypeInfoByType[roomKey],
                    };
                }

                const res = await getCombinedRoomInfo(roomId, { checkin_date, checkout_date });


                // Pre-booked room
                if (room?.book_details_id) {
                    const apiInfo = res?.room_type_info || {};

                    console.log("apiInfo", apiInfo)


                    const roomTypeInfo = {
                        room_type_id: room.room_type_id,
                        room_id: room.room_id,
                        room_type: room.room_type || apiInfo.room_type || "",
                        capacity: Number(room.capacity) || Number(apiInfo.capacity) || 0,
                        exbed_capability: Number(room.exbed_capability) || Number(apiInfo.exbed_capability) || 0,
                        exbed_capability_limit: Number(room.exbed_capability_limit) || Number(apiInfo.exbed_capability_limit) || 0,
                        child_limit: Number(room.child_limit) || Number(apiInfo.child_limit) || 0,
                        extra_bed_charge: Number(room.extra_bed_charge) || Number(apiInfo.extra_bed_charge) || 0,
                        extra_person_charge: Number(room.extra_person_charge) || Number(apiInfo.extra_person_charge) || 0,
                        extra_child_charge: Number(room.extra_child_charge) || Number(apiInfo.extra_child_charge) || 0,
                        room_rate: Number(room.room_rate) || Number(apiInfo.room_rate) || 0,
                        children_min_age: Number(room.children_min_age) || Number(apiInfo.children_min_age) || 0,
                        children_max_age: Number(room.children_max_age) || Number(apiInfo.children_max_age) || 0,
                        accommodation_type: room.accommodation_type || apiInfo.accommodation_type || "",
                        avalible_beds: Number(room?.avalible_beds) || Number(apiInfo?.avalible_beds) || 0,
                        rate_per_bed: Number(room?.rate_per_bed) || Number(apiInfo?.rate_per_bed) || 0,
                    };

                    const complementary = [
                        {
                            complementary_id: room.complementary_id,
                            complementary_price: room.complementary_price,
                            complementary_name: room.complementary_name,
                            complementary_price_type: room.complementary_price_type
                        },
                        ...(res.complementary || []).filter(
                            item => item.complementary_id !== room.complementary_id
                        ),
                    ];

                    setRoomNumbersByType(prev => ({ ...prev, [roomId]: res.rooms || [] }));

                    if (roomId && roomNo) {

                        setRoomTypeInfoByType(prev => ({ ...prev, [roomKey]: roomTypeInfo }));
                        if (room.complementary_id && room.complementary_price) {
                            setComplementryByType(prev => ({ ...prev, [roomKey]: complementary || [] }));
                        } else {
                            setComplementryByType(prev => ({ ...prev, [roomKey]: res.complementary || [] }));
                        }
                    }

                    if (setChildrenMinAge) {
                        setChildrenMinAge(roomTypeInfo.children_min_age || 6);
                    } else if (setChildrenMaxAge) {
                        setChildrenMaxAge(roomTypeInfo.children_max_age || 12);
                    }

                    console.log("roomTypeInfo", roomTypeInfo)
                    return {
                        roomTypeInfo,
                    };
                }

                setRoomNumbersByType(prev => ({ ...prev, [roomId]: res.rooms || [] }));

                if (roomId && roomNo) {
                    setComplementryByType(prev => ({ ...prev, [roomKey]: res.complementary || [] }));
                    setRoomTypeInfoByType(prev => ({ ...prev, [roomKey]: res.room_type_info || {} }));
                    setChildrenMinAge(res.room_type_info.children_min_age || 6);
                    setChildrenMaxAge(res.room_type_info.children_max_age || 12);
                }

                return {
                    roomTypeInfo: res.room_type_info || {},
                };

            } catch (error) {
                console.error(`Error loading room options for ${roomKey}:`, error);
                return null;
            } finally {
                setIsLoading(false);
            }
        },
        [
            roomNumbersByType,
            setRoomNumbersByType,
            setComplementryByType,
            setRoomTypeInfoByType,
            values.checkin_date,
            values.checkout_date
        ]
    );

    return { ensureTypeOptions, isLoading };
};

export default useRoomTypeOptions;